/**
 * Shared pdf.js runtime-asset locations.
 *
 * pdf.js v5 loads its image decoders — OpenJPEG (JPEG2000) and QCMS (colour
 * management) — as separate WASM modules fetched at runtime from `wasmUrl`.
 * Unlike `GlobalWorkerOptions.workerSrc`, `wasmUrl` is NOT global: it has to be
 * supplied to every `getDocument` call and every react-pdf `<Document options>`.
 * When it's missing pdf.js can't initialise OpenJPEG ("OpenJPEG failed to
 * initialize") and every JPEG2000 image — i.e. the images most SCANNED PDFs are
 * built from — fails to decode, so those pages render blank.
 *
 * The wasm files ship in `pdfjs-dist/wasm/` and are served at `/wasm/`
 * (CopyPlugin in webpack.common.js for production; the dev-server static mapping
 * in webpack.dev.js for local dev) — the same serve-at-web-root pattern as
 * `/pdf.worker.min.mjs` and `/mupdf-wasm.wasm`.
 *
 * NOTE: we deliberately do NOT set `standardFontDataUrl` / `cMapUrl`. The text
 * pre-pass runs on MuPDF now (VE-27405), so pdf.js doesn't need them for
 * extraction; and supplying the standard-font programs made pdf.js re-space the
 * (invisible) textLayer by the substitute font's metrics, which shifted text
 * SELECTION by several glyphs on some documents. The textLayer is only used for
 * native selection, so we leave pdf.js on its default (fallback) metrics.
 */

/** Base URL (trailing slash required) pdf.js fetches openjpeg.wasm / qcms_bg.wasm from. */
export const PDF_WASM_URL = '/wasm/';

/**
 * Stable options object for react-pdf's `<Document options={...}>`. MUST stay a
 * module-level constant: react-pdf reloads the whole document whenever the
 * options reference changes, so an inline object would reload it every render.
 */
export const PDFJS_DOCUMENT_OPTIONS = { wasmUrl: PDF_WASM_URL } as const;
